
const getDefaultState = () => ({
    pageName: 'default',
    pageClasses: [],
    modalName: null,
});

const state = getDefaultState();

const getters = {
};

const { body } = document;
const html = document.querySelector('html');
const LOADING_CLASS = 'page-loading';

const mutations = {
    pageEnter (state, newPage) {
        if (state.pageClasses && state.pageClasses.length) {
            body.classList.remove(...state.pageClasses);
            html.removeAttribute('data-pageName');
        }

        state.pageName = newPage.pageName || newPage.$options.name;
        state.pageClasses = newPage.pageClasses;

        body.id = state.pageName;
        html.setAttribute('data-pageName', state.pageName);

        if (body.classList.contains(LOADING_CLASS)) {
            body.classList.remove(LOADING_CLASS);
        }
        if (state.pageClasses && state.pageClasses.length) {
            body.classList.add(...state.pageClasses);
        }
    },
    pageLeave (state) {
        body.classList.add(LOADING_CLASS);
    },

    modalOpen (state, newModal) {
        state.modalName = newModal.modalName;
    },
    modalClose (state) {
        state.modalName = null;
    },
};

const actions = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
